import axios from 'axios';

type ErrorRequestPledgeResult = {
  success: false;
  message: string;
};

type SuccessRequestPledgeResult = {
  success: true;
};

type RequestPledgeResult = ErrorRequestPledgeResult | SuccessRequestPledgeResult;

export const requestPledgesByEmail = async (email: string): Promise<RequestPledgeResult> => {
  try {
    const result = await axios.post<RequestPledgeResult>(`/rails_api/pledge/send_pledges`, {
      email,
    });
    return result.data;
  } catch {
    return {
      success: false,
      message: 'An unknow error occurred',
    };
  }
};
